<span>
  <span class="oi oi-magnifying-glass"></span>

  <input
    #inputText
    type="text"
    placeholder="Find {{ label }}..."
    (keyup)="updateTagFilter()"
    (change)="updateTagFilter()"
  />
</span>

<span *ngIf="items.length === 0">No options available.</span>
<ul>
  <li *ngFor="let item of filteredItems">
    <div style="display: flex; flex-direction: column">
      <div style="display: flex; flex-direction: row">
        <input
          type="checkbox"
          (click)="toggleResultCheck(item, $event)"
          [checked]="item.selected"
          (change)="toggleResultCheck(item, $event)"
        />
        <span>{{ item.text }}</span>
      </div>
      <input
        [hidden]="!item.selected"
        type="text"
        placeholder=""
        (change)="detectChanges(item, $event)"
        [value]="item.value.value"
      />
    </div>
  </li>
</ul>
